import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { Box, Button, Skeleton } from "@mui/material";
import * as Icons from "@mui/icons-material"; // ✅ Import all MUI icons

const Sidebar = ({ enableClos = false }) => {
  const router = useRouter();

  const sidebarContent = [
    {
      id: 2,
      icon_old: "/img/dashboard/sidebar/History.svg",
      icon: "Description", // ✅ MUI "DescriptionIcon"
      name: " Booking History",
      routePath: "/guestbooking/bookinglist",
    }
  ];

  return (
    <div className="sidebar-container">
      <div className="sidebar-menu">
        {sidebarContent.map((item) => {
          const IconComp = Icons[item.icon];
          const isActive = router.asPath === item.routePath;

          return (
            <div key={item.id}>
              <Link
                href={item.routePath}
                className={`menu-item ${isActive ? "active" : ""}`}
              >
                <IconComp className="menu-icon" />
                <span>{item.name}</span>
              </Link>

              {/* Divider only after Card Details */}
              {item.id === 5 && <div className="sidebar-divider" style={{
                margin: "16px 0px"
              }}></div>}
            </div>
          );
        })}
      </div>
      {/* LOGOUT BUTTON */}
      <div className="logout-section d-flex justify-end">
        {
          enableClos &&
          <Button style={{ color: "gray" }} data-bs-dismiss="offcanvas">Close</Button>
        }
      </div>
    </div>
  );
};

export default Sidebar;
